<div class="info-display" [attr.data-testid]="testIds.infoDisplay">
  <div class="info-background-circle" [attr.data-testid]="testIds.infoIconBackground">
    <mat-icon class="info-icon" [attr.data-testid]="testIds.infoIcon" svgIcon="circle-info"></mat-icon>
  </div>
  <div class="info-text" [attr.data-testid]="testIds.infoText">{{ text() }}</div>
</div>
